/**
 * Mutacje logowania/wylogowania (§5, §17.2, §17.3, etap 5 zadanie 1).
 *
 * §17.3: mutacje cookie-session sprawdzają dozwolony `Origin`/`Referer` po stronie serwera
 * (`apps/server/src/http/origin-guard.ts`). Przeglądarka wysyła nagłówek `Origin` samoczynnie
 * dla żądań `POST` (fetch), więc klient nie musi (i nie powinien — nie da się tego zrobić z
 * poziomu JS) ustawiać go ręcznie; `credentials: 'same-origin'` wystarcza, żeby ciasteczko
 * sesji (`HttpOnly`) zostało wysłane/przyjęte na tym samym pochodzeniu (frontend i API dzielą
 * jedno origin, §17.3).
 *
 * §5/§17.2: logowanie ma JEDEN komunikat błędu niezależnie od przyczyny (dane błędne, limit
 * prób, błąd serwera) — dlatego funkcja niżej celowo NIE odróżnia 401/429/5xx ani nie próbuje
 * odczytać treści błędu: sam fakt „nie 2xx" jest jedynym sygnałem, jaki wolno pokazać.
 */

export interface SignInInput {
  email: string;
  password: string;
}

export type SignInResult = { ok: true } | { ok: false };

export async function signInWithEmail(input: SignInInput): Promise<SignInResult> {
  try {
    const response = await fetch('/api/auth/sign-in/email', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(input),
    });
    return { ok: response.ok };
  } catch {
    return { ok: false };
  }
}

export async function signOut(): Promise<void> {
  try {
    await fetch('/api/auth/sign-out', {
      method: 'POST',
      credentials: 'same-origin',
    });
  } catch {
    // Wylogowanie jest najlepszego wysiłku po stronie UI — nawet gdy żądanie sieciowe zawiedzie,
    // wywołujący (AppShell) i tak unieważnia lokalny cache sesji i przekierowuje na /login.
  }
}
